import {
	ParamListBase,
	RouteConfig,
	StackNavigationState,
} from '@react-navigation/native';
import { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { NativeStackNavigationEventMap } from '@react-navigation/native-stack/lib/typescript/src/types';
import { SettingCatchmentArea } from '../app/components';
import {
	AvailabilityScreen,
	BrandsScreen,
	CreateEventScreen,
	CreditCardInformationScreen,
	EventCompleteScreen,
	EventDescriptionScreen,
	EventDetailScreen,
	EventDurationScreen,
	EventHostScreen,
	EventInviteScreen,
	EventLocationScreen,
	EventCatchmentArea,
	EventProductScreen,
	EventsScreen,
	EventUploadMediaScreen,
	HomeScreen,
	LiveEventScreen,
	LoginScreen,
	NetworkScreen,
	PersonalInfoScreen,
	ProductsUploadScreen,
	ProfileScreen,
	SellerAgreementScreen,
	SignupCompleteScreen,
	UserSelectScreen,
	WelcomeScreen,
	YourInformationScreen,
	SaveAsScreen,
	ChatScreen,
	ForgotPassword,
	ResetPassword,
	BrandDetailsScreen,
	UserProfileScreen,
	CheckoutScreen,
	CheckoutAddressScreen,
	PurchaseCompleteScreen,
	OrderDetails,
	VerifyEmail,
	MobileFacebookAuth,
} from '../app/screens';

import { TRootStackParamList } from '../app/types/exportedTypes';

type TNavigationScreensConfig = RouteConfig<
	TRootStackParamList,
	keyof TRootStackParamList,
	StackNavigationState<ParamListBase>,
	NativeStackNavigationOptions,
	NativeStackNavigationEventMap
> & {
	protectedRoute?: boolean;
};

export const ScreenConfig: TNavigationScreensConfig[] = [
	{
		name: 'Events',
		options: { headerShown: false, title: 'Events' },
		component: EventsScreen,
	},
	{
		name: 'Index',
		component: HomeScreen,
		options: { headerShown: false, title: 'Home' },
	},
	{
		name: 'Home',
		component: HomeScreen,
		options: { headerShown: false, title: 'Home' },
	},
	{
		name: 'Welcome',
		options: { headerShown: false, title: 'Welcome' },
		component: WelcomeScreen,
	},
	{
		name: 'EventsAuthorized',
		options: { headerShown: false, title: 'Live Shopping' },
		component: EventsScreen,
		protectedRoute: false,
	},
	{
		name: 'Login',
		options: { headerShown: false, title: 'Sign In' },
		component: LoginScreen,
		protectedRoute: false,
	},
	{
		name: 'ForgotPassword',
		options: { headerShown: false, title: 'Forgot Password' },
		component: ForgotPassword,
		protectedRoute: false,
	},
	{
		name: 'Reset',
		options: { headerShown: false, title: 'Reset Password' },
		component: ResetPassword,
		protectedRoute: false,
	},
	{
		name: 'UserSelect',
		options: { headerShown: false, title: 'Account Type' },
		component: UserSelectScreen,
		protectedRoute: false,
	},
	{
		name: 'PersonalInfo',
		options: { headerShown: false, title: 'Personal Information' },
		component: PersonalInfoScreen,
		protectedRoute: false,
	},
	{
		name: 'SellerAgreement',
		options: { headerShown: false, title: 'Seller Agreement' },
		component: SellerAgreementScreen,
		protectedRoute: false,
	},
	{
		name: 'YourInformation',
		options: { headerShown: false, title: 'Your Information' },
		component: YourInformationScreen,
		protectedRoute: false,
	},
	{
		name: 'CreditCardInformation',
		options: { headerShown: false, title: 'Payment Information' },
		component: CreditCardInformationScreen,
		protectedRoute: false,
	},
	{
		name: 'OrderDetails',
		options: { headerShown: false, title: 'Order Details' },
		component: OrderDetails,
		protectedRoute: true,
	},
	{
		name: 'VerifyEmail',
		options: { headerShown: false, title: 'Verification' },
		component: VerifyEmail,
		protectedRoute: false,
	},
	{
		name: 'MobileFacebookAuth',
		options: { headerShown: false, title: 'Facebook Login' },
		component: MobileFacebookAuth,
		protectedRoute: false,
	},
	{
		name: 'SettingCatchmentArea',
		options: { headerShown: false, title: 'Setting Catchment Area' },
		component: SettingCatchmentArea,
		protectedRoute: false,
	},
	{
		name: 'Availability',
		options: { headerShown: false, title: 'Availability' },
		component: AvailabilityScreen,
		protectedRoute: false,
	},
	{
		name: 'ProductsUpload',
		options: { headerShown: false, title: 'Upload Products' },
		component: ProductsUploadScreen,
		protectedRoute: false,
	},
	{
		name: 'SignupComplete',
		options: { headerShown: false, title: 'Account Created' },
		component: SignupCompleteScreen,
		protectedRoute: false,
	},
	{
		name: 'SaveAs',
		options: { headerShown: false, title: 'Save As' },
		component: SaveAsScreen,
	},
	// {
	// 	name: 'Events',
	// 	options: { headerShown: false },
	// 	component: EventsScreen,
	// },
	{
		name: 'LiveEvent',
		options: { headerShown: false, title: 'Live Event' },
		component: LiveEventScreen,
		protectedRoute: true,
	},
	{
		name: 'LiveEvent',
		options: { headerShown: false, title: 'Live Event' },
		component: LiveEventScreen,
		protectedRoute: false,
	},
	{
		name: 'CreateEvent',
		options: { headerShown: false, title: 'Create Event' },
		component: CreateEventScreen,
	},
	{
		name: 'EventDetail',
		options: { headerShown: false, title: 'Event Details' },
		component: EventDetailScreen,
	},
	{
		name: 'EventDuration',
		options: { headerShown: false, title: 'Event Duration' },
		component: EventDurationScreen,
	},
	{
		name: 'EventLocation',
		options: { headerShown: false, title: 'Event Location' },
		component: EventLocationScreen,
	},
	{
		name: 'CatchmentArea',
		options: { headerShown: false, title: 'Catchment Area' },
		component: EventCatchmentArea,
	},
	{
		name: 'EventUpload',
		options: { headerShown: false, title: 'Event Media' },
		component: EventUploadMediaScreen,
	},
	{
		name: 'EventInvite',
		options: { headerShown: false, title: 'Event Invite' },
		component: EventInviteScreen,
	},
	{
		name: 'EventHost',
		options: { headerShown: false, title: 'Event Host' },
		component: EventHostScreen,
	},
	{
		name: 'EventProduct',
		options: { headerShown: false, title: 'Event Products' },
		component: EventProductScreen,
	},

	{
		name: 'EventComplete',
		options: { headerShown: false, title: 'Event Complete' },
		component: EventCompleteScreen,
	},
	{
		name: 'EventDescription',
		options: { headerShown: false, title: 'Event Description' },
		component: EventDescriptionScreen,
		protectedRoute: false,
	},
	{
		name: 'EventDescription',
		options: { headerShown: false, title: 'Event Description' },
		component: EventDescriptionScreen,
		protectedRoute: true,
	},
	{
		name: 'Network',
		options: { headerShown: false, title: 'Network' },
		component: NetworkScreen,
	},
	{
		name: 'Brands',
		options: { headerShown: false, title: 'Brands' },
		component: BrandsScreen,
	},
	{
		name: 'BrandDetails',
		options: { headerShown: false, title: 'Brand Details' },
		component: BrandDetailsScreen,
	},
	{
		name: 'Profile',
		options: { headerShown: false, title: 'Profile' },
		component: ProfileScreen,
	},
	{
		name: 'UserProfile',
		options: { headerShown: false, title: 'User Profile' },
		component: UserProfileScreen,
	},
	{
		name: 'Chat',
		options: { headerShown: false, title: 'Chat' },
		component: ChatScreen,
		protectedRoute: true,
	},
	{
		name: 'Checkout',
		options: { headerShown: false, title: 'Checkout' },
		component: CheckoutScreen,
		protectedRoute: true,
	},
	{
		name: 'Checkout',
		options: { headerShown: false, title: 'Checkout' },
		component: CheckoutScreen,
		protectedRoute: false,
	},
	{
		name: 'CheckoutAddress',
		options: { headerShown: false, title: 'Delivery Address' },
		component: CheckoutAddressScreen,
		protectedRoute: true,
	},
	{
		name: 'CheckoutAddress',
		options: { headerShown: false, title: 'Delivery Address' },
		component: CheckoutAddressScreen,
		protectedRoute: false,
	},
	{
		name: 'PurchaseComplete',
		options: { headerShown: false, title: 'Order Confirmed' },
		component: PurchaseCompleteScreen,
		protectedRoute: true,
	},
	{
		name: 'PurchaseComplete',
		options: { headerShown: false, title: 'Order Confirmed' },
		component: PurchaseCompleteScreen,
		protectedRoute: false,
	},
];
